import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import EditCouponForm from "../../components/coupon/EditCouponForm";

export default function EditCoupon() {
    const { productId, couponId } = useParams<{ productId: string, couponId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=coupon`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Cupom"
                description="Editar cupom para o produto"
            />
            <PageBreadcrumb
                pageTitle="Editar Cupom"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditCouponForm
                    couponId={couponId || ''}
                    productId={productId || ''}
                    onSuccess={() => {
                        navigate(`/products/edit/${productId}?tab=coupon`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao editar cupom:", error);
                    }}
                />
            </div>
        </>
    );
}